import axios from "axios";

export const loginApi = async (userData, signal) => {
  // post request to the server to perform user login
  // userData (JSON): object with user data (email (String), password (String), stayLoggedIn (Boolean))
  // signal (AbortSignal): the AbortSignal used to cancel the API request if needed
  try {
    const { email, password, stayLoggedIn } = userData;
    const { data } = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/auth/login`,
      {
        email,
        password,
        stayLoggedIn,
      },
      { signal }
    );
    return data;
  } catch (error) {
    //status code not in 200s
    if (!(error.name === "AbortError" || error.name === "CanceledError")) {
      // custom error message from back end
      const newErr = new Error(error.response?.data?.message);
      newErr.status = error.response?.request?.status;
      throw newErr;
    }
  }
};

export const registerApi = async (userData, signal) => {
  // post request to the server to register a new user
  // userData (JSON): object with user data (firstName (String), lastName (String), email (String), password (String))
  // signal (AbortSignal): the AbortSignal used to cancel the API request if needed
  try {
    const { firstName, lastName, email, password } = userData;
    const { data } = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/auth/register`,
      {
        firstName,
        lastName,
        email,
        password,
      },
      { signal }
    );
    return data;
  } catch (error) {
    //status code not in 200s
    if (!(error.name === "AbortError" || error.name === "CanceledError")) {
      // custom error message from back end
      const newErr = new Error(error.response?.data?.message);
      newErr.status = error.response?.request?.status;
      throw newErr;
    }
  }
};